import React from 'react';

/**
 *
 * @param {Array<import('ui/base/StepModal').ModalStep>} steps
 * @param {string} defaultStep key of the default step
 * @returns {{
 * handlePrev: function
 * handleNext: function
 * isLastStep: boolean
 * currentStep: import('ui/base/StepModal').ModalStep
 * currentStepKey: string
 * steps: Array<import('ui/base/StepModal').ModalStep>,
 * currentStepIndex: number,
 * }}
 */
const useSteps = (steps, defaultStep) => {
  const [currentStepKey, setCurrentStepKey] = React.useState(defaultStep ?? steps[0]?.key);

  const currentStepIndex = steps.findIndex(({ key }) => currentStepKey === key);
  const currentStep = steps[currentStepIndex];

  // We allow handling the last step using a function or a boolean under `isLastStep`
  // Otherwise, we assume that a step without nextStep function is the last one
  const isLastStep =
    typeof currentStep?.isLastStep === 'function'
      ? currentStep.isLastStep()
      : currentStep?.isLastStep ?? !currentStep?.nextStep;

  const handlePrev = React.useCallback(() => setCurrentStepKey(currentStep.prevStep), [currentStep]);
  const handleNext = React.useCallback(() => setCurrentStepKey(currentStep.nextStep), [currentStep]);

  return React.useMemo(
    () => ({
      handlePrev,
      handleNext,
      isLastStep,
      currentStep,
      currentStepKey,
      steps: steps ?? [],
      currentStepIndex: currentStepIndex ?? -1,
    }),
    [steps, currentStepKey, currentStepIndex, currentStep, isLastStep, handlePrev, handleNext]
  );
};

export default useSteps;
